module.exports = __webpack_public_path__ + "media/bootstrap-icons/funnel-fill-622eab92.svg";